import dayjs from 'dayjs';
import moment from 'moment';

export const formatHHmmDDMMYYYY = (string) =>
  dayjs(string).format('HH:mm - DD/MM/YYYY');

export const formatDDMMHHmm = (string) => dayjs(string).format('DD/MM HH:mm');

export const formatDDMMYYYYHHmm = (string) =>
  dayjs(string).format('DDMMYYYY_HHmm ');

export const formatDDMMYYYY = (string) => dayjs(string).format('DD/MM/YYYY');

export const formatHHmm = (string) => dayjs(string).format('HH:mm');

export const formatHHMMDDMM = (string) => dayjs(string).format('HH:mm DD/MM');

export const formatDDMMYYYYHHMM = (string) =>
  dayjs(string).format('DD/MM/YYYY - HH:mm');

export const formatTime = (date) => dayjs(date).format('ddd hh:mm A');

export const formatDDM = (string) => dayjs(string).format('DD/M');

export const formatToDate = (date) => {
  const d = date || new Date();
  return dayjs(d).hour(0).minute(0).second(0);
};
export const formatEndDate = (date) => {
  const d = date || new Date();
  return dayjs(d).hour(23).minute(59).second(59);
};

export const formatToDateISO = (date) => {
  if (!date) {
    return;
  }
  const changeDate = Date.parse(date);
  const result = dayjs(changeDate).hour(0).minute(0).second(0);
  return result.toISOString();
};

export const formatMinsToHrs = (string) => {
  let hours = string / 60;
  let rhours = Math.floor(hours);
  let minutes = (hours - rhours) * 60;
  let rminutes = minutes > 0 ? Math.round(minutes) : '00';
  return rhours + ' : ' + rminutes;
};

export const roundUpMins = (value) => {
  let hours = value / 60;
  let rhours = Math.floor(hours);
  let minutes = (hours - rhours) * 60;
  let rminutes = minutes > 0 ? Math.round(minutes) : '00';
  let number = parseInt(rhours);
  if (number < 1000) {
    return number.toString();
  } else {
    var resultHour = Math.round(number / 1000);
    resultHour = resultHour.toString() + 'k';
  }
  return resultHour;
};

export const getTimeFromDate = (date) => {
  let dates = new Date(date);
  var hours = dates.getHours();
  var minutes = dates.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = hours + ':' + minutes + ampm;
  return strTime;
};

export const dateConversion = (startdate) => {
  var date_time = new Date(startdate);
  let dayOfWeekNumber = date_time.getDay();
  let getdate = date_time.getDate();
  let nameOfDay;
  var month = date_time.toLocaleString('default', { month: 'long' });

  switch (dayOfWeekNumber) {
    case 0:
      nameOfDay = 'Sunday';

      break;
    case 1:
      nameOfDay = 'Monday';

      break;
    case 2:
      nameOfDay = 'Tuesday';

      break;
    case 3:
      nameOfDay = 'Wednesday';

      break;
    case 4:
      nameOfDay = 'Thursday';

      break;
    case 5:
      nameOfDay = 'Friday';

      break;
    case 6:
      nameOfDay = 'Saturday';

      break;
  }

  const nth = (getdate) => {
    if (getdate > 3 && getdate < 21) return 'th';
    switch (getdate % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  var hours = date_time.getHours();
  var minutes = date_time.getMinutes();
  var ampm = hours < 12 ? 'AM' : 'PM';
  hours = hours % 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var strTime = `${hours == '0' ? 12 : hours}:${minutes}${ampm}`;
  let date_conversation = {
    nameOfDay: nameOfDay,
    getdate: getdate,
    nth: nth(getdate),
    month: month,
    strTime: strTime,
  };

  return date_conversation;
};

export const titleExtensionWithTimeZone = (dateStart, dateEnd) => {
  if (dateStart && dateEnd) {
    const timeStart = new Date(dateStart).toISOString();
    const timeEnd = new Date(dateEnd).toISOString();
    var time_Start = dateConversion(timeStart);
    var time_End = dateConversion(timeEnd);
    return `${time_Start.nameOfDay} ${time_Start.getdate}${time_Start.nth} ${time_Start.month} ${time_Start.strTime} - ${time_End.nameOfDay} ${time_End.getdate}${time_End.nth} ${time_End.month} ${time_End.strTime}`;
  }
};

export const convertMinutesToHours = (minutes) => {
  const hours = Math.floor(minutes / 60);
  return parseFloat(hours);
};
